<template>
  <div class="container">
    <div class="visit-page trans">
      <visit-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit">
          {{ this.$route.params.pv.name }}: 诚邀您参加,欢迎报名
        </h2>
        <div class="visit-detail shadow">
          <h2 class="dl-tit">项目介绍:</h2>
          <p>{{ this.$route.params.pv.content }}</p>
          <!-- <img src="@/assets/img/msg.png" alt=""> -->
          <!-- <p>项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容</p>
                     <p>项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容项目内容</p> -->
          <RichHtml
            style="margin-left: 4px; margin-right: 4px"
            :content="$route.params.pv.detil"
          ></RichHtml>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import visitHeader from "@/components/header"
  import RichHtml from "@/components/RichHtml"

  export default {
    name: "visitPage",
    components: {
      visitHeader,
      RichHtml,
    },
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "报名参观",
        },
      }
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
      padding-left: 8px;
      margin-top: 30px;
      border-left: 4px solid var(--main-color);
      font-size: 16px;
      font-weight: bold;
      color: #424242;
    }

    .visit-detail {
      margin: 15px auto;
      padding: 15px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 5px;

      p {
        margin: 15px 0;
        line-height: 25px;
        color: #666;
      }

      img {
        width: 100%;
      }
    }
  }
</style>
